export interface ThemeCustomizerState {
    isOpen: boolean
}

const state: ThemeCustomizerState = {
    isOpen: false,
}

const mutations = {
    TOGGLE_THEME_CUSTOMIZER(state: ThemeCustomizerState) {
        state.isOpen = !state.isOpen
    },
    SET_THEME_CUSTOMIZER(state: ThemeCustomizerState, isOpen: boolean) {
        state.isOpen = isOpen
    },
}

const actions = {
    toggleThemeCustomizer({ commit }: any) {
        commit("TOGGLE_THEME_CUSTOMIZER")
    },
    setThemeCustomizer({ commit }: any, isOpen: boolean) {
        commit("SET_THEME_CUSTOMIZER", isOpen)
    },
}

const getters = {
    isThemeCustomizerOpen: (state: ThemeCustomizerState) => state.isOpen,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
